module.exports = __webpack_public_path__ + "img/banner.22d09d62.jpg";